export default "__VITE_ASSET__hBJEyCSO__"